'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('formSubmitCtrl', ['$scope', function($scope){
	$scope.form;
	$scope.submitted = false;
	$scope.loading = false;
	$scope.field = askquestionData.recaptcha.field;
	$scope.sitekey = askquestionData.recaptcha.siteKey;
	$scope.recaptchaResponse = null;
	$scope.captchaSubmitted = false;
	$scope.emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,4}$/;
	
	var enableBtn = function () {
		$scope.captchaSubmitted = true;
		$scope.$apply();
	};
	window.enableBtn = enableBtn;
	var disableBtn = function () {
		$scope.captchaSubmitted = false;
		$scope.$apply();
	};
	window.disableBtn = disableBtn;

		$scope.formSubmit = function (e) {
			e.preventDefault();
			$scope.submitted = true;
//		$scope.form[0].submit();

			if (typeof grecaptcha !== 'undefined') {
				grecaptcha.ready(function () {
					if ($scope.sitekey) {
						$scope.loading = true;
						grecaptcha.execute($scope.sitekey, {action: 'submit'}).then(function (token) {
							console.log(token);
							$scope.recaptchaResponse = token;

							var inp = document.createElement('input');
							inp.type = 'hidden';
							inp.name = $scope.field, //'g-recaptcha-response';
									inp.value = token;
							$scope.form[0].appendChild(inp);
							$scope.form[0].submit();
						});
					} else {
						$scope.submited = true;
						console.log("no recaptcha siteKey");
					}
				});
			} else {
				$scope.loading = false;
				console.log("no recaptcha service");
			}
		};
}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

